import clx from 'classnames'
import _ from 'lodash'
import styles from './LoadingSpinner.css'

export const SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
}

const LoadingSpinner = ({ size = SIZE.SMALL, className }) => {
  return (
    <div className={styles.spinnerArea}>
      <div
        className={clx(
          styles.LoadingSpinner,
          { [className]: className },
          { [styles[SIZE.SMALL]]: size === SIZE.SMALL },
          { [styles[SIZE.MEDIUM]]: size === SIZE.MEDIUM },
          { [styles[SIZE.LARGE]]: size === SIZE.LARGE }
        )}
      >
        {
          _.times(12, index => (
            <div
              key={index}
              className={clx(
                styles.spinnerItem,
                { [styles[SIZE.SMALL]]: size === SIZE.SMALL },
                { [styles[SIZE.MEDIUM]]: size === SIZE.MEDIUM },
                { [styles[SIZE.LARGE]]: size === SIZE.LARGE }
              )}
            />
          ))
        }
      </div>
    </div>
  )
}

export default LoadingSpinner
